import { BuildingLayerPreset } from "../../model/types";

export const SUBLAYER_PRESET_KEYS: Record<BuildingLayerPreset, readonly string[]> = {
  custom: [],
  rooftop_objects: ["skylight", "hvac", "chimney", "solar_panel", "vent", "antenna", "obstacle", "other"],
  vegetation: ["trees"],
};

export const LAYER_PRESET_ORDER: BuildingLayerPreset[] = ["rooftop_objects", "vegetation", "custom"];

export const CUSTOM_KEY: BuildingLayerPreset = "custom";
